import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FileUploadZone = ({ onFileSelect, isUploading, uploadProgress }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e?.dataTransfer?.files);
    if (files?.length > 0) {
      handleFileSelection(files?.[0]);
    }
  };

  const handleFileSelection = (file) => {
    const allowedTypes = [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];
    
    const maxSize = 10 * 1024 * 1024; // 10MB

    if (!allowedTypes?.includes(file?.type)) {
      alert('Selecione um arquivo CSV ou Excel (.csv, .xls, .xlsx)');
      return;
    }

    if (file?.size > maxSize) {
      alert('O arquivo deve ter menos de 10MB');
      return;
    }

    onFileSelect(file);
  };

  const handleFileInputChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      handleFileSelection(file);
    }
  };

  const openFileDialog = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div className="bg-card rounded-lg border-2 border-dashed border-border p-8">
      <div
        className={`relative transition-all duration-200 ${
          isDragOver ? 'border-primary bg-primary/5' : ''
        }`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xls,.xlsx"
          onChange={handleFileInputChange}
          className="hidden"
          disabled={isUploading}
        />

        <div className="text-center">
          {isUploading ? (
            <div className="space-y-4">
              <Icon name="Upload" size={48} className="text-primary mx-auto animate-gentle-pulse" />
              <div>
                <h3 className="text-lg font-medium text-foreground mb-2">Enviando arquivo...</h3>
                <div className="w-full bg-muted rounded-full h-2 mb-2">
                  <div 
                    className="bg-primary h-2 rounded-full transition-all duration-300"
                    style={{ width: `${uploadProgress}%` }}
                  />
                </div>
                <p className="text-sm text-muted-foreground">{uploadProgress}% concluído</p>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <Icon name="Upload" size={48} className="text-muted-foreground mx-auto" />
              <div>
                <h3 className="text-lg font-medium text-foreground mb-2">
                  Arraste o arquivo aqui ou clique para procurar
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  Formatos suportados: CSV, Excel (.csv, .xls, .xlsx)
                </p>
                <p className="text-xs text-muted-foreground mb-6">
                  Tamanho máximo do arquivo: 10MB
                </p>
                <Button
                  variant="outline"
                  onClick={openFileDialog}
                  iconName="FolderOpen"
                  iconPosition="left"
                >
                  Escolher arquivo
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* File Requirements */}
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <h4 className="text-sm font-medium text-foreground mb-3 flex items-center">
          <Icon name="Info" size={16} className="mr-2" />
          Requisitos do arquivo
        </h4>
        <div className="grid md:grid-cols-2 gap-4 text-xs text-muted-foreground">
          <div>
            <p className="font-medium mb-2">Colunas obrigatórias:</p>
            <ul className="space-y-1">
              <li>• Nome Completo</li>
              <li>• CPF</li>
              <li>• Título de Eleitor</li>
              <li>• E-mail</li>
              <li>• Telefone</li>
            </ul>
          </div>
          <div>
            <p className="font-medium mb-2">Colunas opcionais:</p>
            <ul className="space-y-1">
              <li>• Data de Nascimento</li>
              <li>• Endereço</li>
              <li>• Cidade</li>
              <li>• Estado</li>
              <li>• CEP</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadZone;